.checkbox {
    margin-bottom: 6px;
}

.checkbox:last-child {
    margin-bottom: 0;
}
